import script from "./CustomLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomLoading.vue?vue&type=script&lang=ts&setup=true"

import "./CustomLoading.vue?vue&type=style&index=0&id=53fac6c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53fac6c2"]])

export default __exports__